import { render, staticRenderFns } from "./sidePanelInvestment.vue?vue&type=template&id=43fab3e1"
import script from "./sidePanelInvestment.vue?vue&type=script&lang=js"
export * from "./sidePanelInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports